class i extends EventTarget {
  tile;
  imageRequest;
  tileUrl;
  tileKey;
  fetchFn;
  abortController;
  data;
  /**
   * Creates an instance of CacheableTile.
   *
   * @constructor
   * @param {FetchableTile} fetchableTile
   * @param {FetchFn} [fetchFn] Optional fetch function to use
   */
  constructor(t, e) {
    super(), this.tile = t.tile, this.imageRequest = t.imageRequest, this.tileUrl = t.tileUrl, this.tileKey = t.tileKey, this.fetchFn = e, this.abortController = new AbortController();
  }
  /**
   * Whether a tile has fetched its data
   *
   * @returns {boolean}
   */
  isCachedTile() {
    return this.data !== void 0;
  }
  /**
   * Abort the fetch
   */
  abort() {
    this.abortController.signal.aborted || this.abortController.abort();
  }
}
export {
  i as default
};
//# sourceMappingURL=CacheableTile.js.map
